import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {CampaignsService_GetAppInstallTeaserLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/campaigns/v1/service.grpc.lazy';

export const useAppInstallTeaserData = () => {
  return useGrpcRequest(
    CampaignsService_GetAppInstallTeaserLazy,
    {},
    {
      refetchInterval: THIRTY_SECONDS,
      refetchOnWindowFocus: true,
      staleTime: ONE_MINUTE,
    },
  );
};

const ONE_MINUTE = 60 * 1000;
const THIRTY_SECONDS = 30 * 1000;
